// Our main CSS
import '../css/app.css'

const heroSlider = document.querySelector('.hero-slider')


if (heroSlider) {
  import('./heroSlider').then((module) => {
    module.default()
  })
}

const activities = document.getElementById('activities')
if (activities) {
  import('./activities').then((module) => {
    module.default(activities)
  })
}

const contactForm = document.getElementById('contact-form')
if (contactForm) {
  import('./contactForm').then((module) => {
    console.log('yes')
    module.default(contactForm)
  })
}

// Ensure the DOM is fully loaded before running the script
document.addEventListener('DOMContentLoaded', () => {
  // Initialize variables
  let lastScrollTop = 0;
  const initialMenu = document.querySelector('.initial-menu');
  const scrollMenu = document.querySelector('.scroll-menu');
  const menuToggles = document.querySelectorAll('.menu-toggle');
  const overlayMenu = document.querySelector('.overlay-menu');

  // Handler for scroll events
  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > 200 && initialMenu) {
      // Scrolled past 200px
      initialMenu.classList.add('hidden');
    }

    if (scrollTop < 100) {
      // At the top
      scrollMenu.classList.remove('hide');
    } else if (scrollTop > lastScrollTop) {
      // Scrolling down and not at the top
      scrollMenu.classList.add('hide');
      scrollMenu.classList.remove('show');
    } else {
      // Scrolling up or at the top
      scrollMenu.classList.remove('hide');
      scrollMenu.classList.add('show');
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
  };

  // Handler for menu toggle clicks
  const toggleOverlayMenu = () => {
    overlayMenu.classList.toggle('visible');
    const isVisible = overlayMenu.classList.contains('visible');

    if (isVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  };

  // Add event listeners
  window.addEventListener('scroll', handleScroll);

  menuToggles.forEach((toggle) => {
    toggle.addEventListener('click', toggleOverlayMenu);
  });

  // Optional: Cleanup event listeners when the page is unloaded
  // This is generally not necessary unless you're dynamically adding/removing components
  window.addEventListener('beforeunload', () => {
    window.removeEventListener('scroll', handleScroll);
    menuToggles.forEach((toggle) => {
      toggle.removeEventListener('click', toggleOverlayMenu);
    });
  });
});